/**
 * Returns normalized (from 0 to 1) difference between two numbers.
 */
export const calculateDiff = (a: number, b: number) => {
    const isArgumentsInvalid = Number.isNaN(a)
        || Number.isNaN(b)
        || a === null
        || b === null
        || b === 0;

    if (isArgumentsInvalid) return null;
    return (a - b) / b;
};
